import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../_models/user';
import { AppConfig } from '../app.config';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getAll() {
        //${AppConfig.settings.apiServer.url}
        return this.http.get<User>(`http://localhost:7494/api/users`);
    }
}